import axios from 'axios'
import apiAuth from '../authData.ts'

export default async () => {
  const authData = apiAuth.auth
  return await axios.get(`${process.env.REACT_APP_API_URL}/medium/posts`, {
    auth: authData,
  })
}
